export default __webpack_public_path__ + "static/media/fablab-floorplan.e30659a0.png";